import { createFileRoute, useRouter } from "@tanstack/react-router";
import { PhoneAuth } from "../components/PhoneAuth";
import { useAuth } from "../hooks/useAuth";
import { PageLayout } from "../components/PageLayout";
import { ClipboardCheck } from "lucide-react";
import { useCopy } from "../i18n/locale";

export const Route = createFileRoute("/login")({
    component: LoginComponent,
});

function LoginComponent() {
    const { isAuthenticated, user, isLoading } = useAuth();
    const router = useRouter();
    const copy = useCopy();

    // Show loading state while auth is being determined
    if (isLoading) {
        return (
            <PageLayout
                title={copy.common.loading}
                description={copy.common.checkingAuth}
                icon={ClipboardCheck}
                theme="green"
            >
                <div className="text-center animate-pulse">
                    <div className="bg-green-200 mx-auto mb-4 rounded-full w-16 h-16"></div>
                    <p className="text-slate-600">{copy.login.loading}</p>
                </div>
            </PageLayout>
        );
    }

    // Redirect if already authenticated (only after loading is complete)
    if (isAuthenticated && user) {
        router.navigate({ to: "/profile" });
        return null;
    }

    return (
        <PageLayout title={copy.login.title} description={copy.login.description} icon={ClipboardCheck} theme="green">
            <PhoneAuth onSuccess={() => {}} />
        </PageLayout>
    );
}
